import {Tabs} from "antd";
import {SystemReports} from "./SystemReports";
import {Devices} from "../../components/ResponsiveView/consts.js";
import {ResponsiveView} from "../../components/index.jsx";
import {SystemDashboardTabKeys, SystemDashboardTabKeysToName} from "./consts.js";
import "./system-dashboard.css";
import {getTabIdByUrlPath} from "./utils.js";
import {SystemOrdersWrapper} from "./SystemOrders";
import {SystemBriefsWrapper} from "./SystemBriefs";
import {SystemProvidersWrapper} from "./SystemProviders";
import React from "react";

export const SystemDashboard = ({history}) => {
    return (
        <>
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <Tabs
                    className="system-dashboard-tabs-container"
                    onTabClick={key => history.push(`/system/${key}`)}
                    activeKey={SystemDashboardTabKeys[getTabIdByUrlPath()] ?? SystemDashboardTabKeys.orders}
                    centered={true}
                    items={[
                        {
                            label: SystemDashboardTabKeysToName[SystemDashboardTabKeys.providers],
                            key: SystemDashboardTabKeys.providers,
                            children: <SystemProvidersWrapper />
                        },
                        {
                            label: SystemDashboardTabKeysToName[SystemDashboardTabKeys.briefs],
                            key: SystemDashboardTabKeys.briefs,
                            children: <SystemBriefsWrapper />
                        },
                        {
                            label: SystemDashboardTabKeysToName[SystemDashboardTabKeys.reports],
                            key: SystemDashboardTabKeys.reports,
                            children: <SystemReports />
                        },
                        {
                            label: SystemDashboardTabKeysToName[SystemDashboardTabKeys.orders],
                            key: SystemDashboardTabKeys.orders,
                            children: <SystemOrdersWrapper />
                        }
                    ]}
                />
            </ResponsiveView>
        </>
    );
};
